import { Parameter } from "@/v2/models/parameters";

export const mapperMixin = {
    methods: {
        /**
         * Constructs a mapper parameter object based on it's constituent Parameter Objects
         * @function
         * @param {Parameter} parameter Parameter object to construct
         * @return {Object} Parameter object.
         */
        createMapperParameter(parameter) {
            Object.keys(parameter).forEach((mapperName) => {
                if (parameter[mapperName] instanceof Parameter) {
                    this.createMapperParameter(parameter[mapperName]);
                }
                else if (parameter[mapperName] == null){
                    parameter[mapperName] = this[`_${mapperName}`];
                }
            })

            return parameter;
        }
    }
};

export default mapperMixin;
